import React from "react";
import { AlertCircle, CheckCircle2, X } from "lucide-react";

const VARIANTS = {
  error: {
    icon: AlertCircle,
    iconClass: "text-red-500",
    title: "Erro",
    buttonClass: "bg-red-600 hover:bg-red-500",
  },
  success: {
    icon: CheckCircle2,
    iconClass: "text-emerald-500",
    title: "Sucesso",
    buttonClass: "bg-emerald-600 hover:bg-emerald-500",
  },
  warning: {
    icon: AlertCircle,
    iconClass: "text-amber-500",
    title: "Atenção",
    buttonClass: "bg-amber-600 hover:bg-amber-500",
  },
};

export function extrairMensagemErro(err, fallback = "Ocorreu um erro inesperado.") {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.mensagem) return data.mensagem;
  if (data?.message) return data.message;
  if (data?.errors) return Object.values(data.errors).flat().join("\n");
  if (err?.message) return err.message;
  return fallback;
}

const CenteredAlert = ({ show, variant = "error", title, message, onClose }) => {
  if (!show || !message) return null;

  const cfg = VARIANTS[variant] || VARIANTS.error;
  const Icon = cfg.icon;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      <div
        role="alertdialog"
        aria-modal="true"
        className="relative w-full max-w-md rounded-2xl zen-card p-6 shadow-xl dark:bg-slate-950/90 dark:border-white/10"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-white/10"
          title="Fechar"
        >
          <X size={18} className="text-gray-600 dark:text-slate-200" />
        </button>

        <div className="flex flex-col items-center text-center gap-3 pt-2">
          <Icon size={40} className={cfg.iconClass} />
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            {title || cfg.title}
          </h3>
          <p className="text-sm text-gray-600 dark:text-slate-300 whitespace-pre-line">
            {message}
          </p>
          <button
            type="button"
            onClick={onClose}
            className={`mt-2 px-6 py-2.5 rounded-xl text-white text-sm font-semibold ${cfg.buttonClass}`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CenteredAlert;
